// extracted by mini-css-extract-plugin
module.exports = {"blackoutProtection":"BlackoutProtection_blackoutProtection__pJga1","ef-box":"BlackoutProtection_ef-box__8qPAA"};